/**
 * Chama a função de exibição|criação do carrossel caso o botão horus
 * seja clicado
 */
function HorusAprovacoes(){
  const horusButton = $('[data-horus]');
  horusButton.on('click', horusButtonHandler);
}

/**
 * Usa uma requisição ajax para criação dos modais caso não exista
 */
function horusButtonHandler(){
  const id = $(this).data('expensesId');
  const containerId = `#blueimp-carousel-${id}`;
  const carousel = createContainer(id, containerId);
  const content = carousel.find('.content');
  const gallery = blueImpBuild(containerId, content);

  if (!carousel.find('.content').find('[data-position]').length) {
    $.ajax({
      'url': route('app.aprovacoes.horus-modal', {'id': id}),
      'success': function(modal){
        content.html(modal);
        blueImpLoading(containerId, content, gallery);
      }
    });
  }
}

/**
 * Cria a base do container da galeria, caso não exista
 * @param  {number} id
 * @param  {string} containerId
 * @return {object}
 */
function createContainer(id, containerId){
  if (!$(containerId).length) {
    $('#container').append(
      `<div
        id="blueimp-carousel-${id}"
        class="blueimp-gallery blueimp-gallery--horus-card blueimp-gallery-controls"
      >
        <div class="slides"></div>
        <a class="prev horus-gallery__left">‹</a>
        <a class="next horus-gallery__right">›</a>
        <a class="close">×</a>
        <ol class="indicator"></ol>
        <div class="content hidden"></div>
      </div>`
    );
  }
  return $(containerId);
}

/**
 * Constroi o carrossel
 * @param  {number} containerId
 * @param  {object} content
 * @return {object}
 */
function blueImpBuild(containerId, content){
  const pixel = '/assets/images/site/intro-mask.png';
  let slides = [
    {
      href: pixel
    }
  ];

  if (content.children().length) {
    slides = content.children();
  }

  return window.blueimp.Gallery(
    slides,
    {
      carousel: true,
      continuous: true,
      clearSlides: false,
      closeOnEscape: true,
      startSlideshow: false,
      container: containerId,
      closeOnSlideClick: true,
      toggleControlsOnReturn: false,
      toggleControlsOnSlideClick: false,
      onopened: function(){
        blueImpOpened(containerId, content, this)
      },
      onslide: function(position, slide){
        blueImpSlide(containerId, content, slide, position)
      },
    }
  );
}

/**
 * Carrega os modais após o carrossel ter sido aberta.
 * Para o primeiro clique no botão
 * @param  {number} containerId
 * @param  {object} content
 * @param  {object} gallery
 */
function blueImpLoading(containerId, content, gallery){
  const slides = $(containerId).find('.slides').find('.slide');
  const firstSlide = slides.first();
  const contentChildren = content.children();

  //Cria o conteúdo do primeiro slide
  firstSlide.html(contentChildren.first().html());
  firstSlide.find('[data-toggle="tooltip"]').tooltip();

  //Cria os demais slides
  if (contentChildren.length > 1) {
    gallery.add(contentChildren.slice(1));

    // Como é o primeiro de vários slides, esconde a seta a esquerda
    $(containerId).addClass('blueimp-gallery-left');
  }
  slides.removeClass('slide-loading');
}

/**
 * Função para carregar os modais após o carrossel ser aberta
 * @param  {object} content
 * @param  {object} slide
 */
function blueImpOpened(containerId, content, slide){
  const slides = $(slide.container).find('.slides').find('.slide');
  slides.addClass('slide-loading');
  if (slides.length > 1) {
    // Como é o primeiro de vários slides, esconde a seta a esquerda
    $(slide.container).addClass('blueimp-gallery-left');
  }
  slides.each(function(){
    const position = $(slide).data('index');
    $(slide).html(content.find(`[data-position=${position}]`).html());
    $(slide).find('[data-toggle="tooltip"]').tooltip();
  });
}

/**
 * Função para carregar os modais com a mudança de slide
 * @param  {object} content
 * @param  {object} slide
 * @param  {number} position
 */
function blueImpSlide(containerId, content, slide, position) {
  const container = $(containerId);
  const slides = container.find('.slides').find('.slide');

  if (slides.length > 1) {
    container.removeClass('blueimp-gallery-left')
      .removeClass('blueimp-gallery-right');

    // Primeiro
    if (position == 0) {
      container.addClass('blueimp-gallery-left');

    // Último
    } else if (position == slides.length - 1) {
      container.addClass('blueimp-gallery-right');

    }
  }

  if(!$(slide).find('[data-card-id]').length){
    const modal = content.find(`[data-position=${position}]`);
    $(slide).html(modal.html());
    $(slide).find('[data-toggle="tooltip"]').tooltip();
    if (!modal.children().length && position) {
      $(slide).addClass('slide-error');
    }
  }
}

module.exports = {
  init: HorusAprovacoes,
  url: /\/aprovacoes\/\d+/
}
